import expandableText from './_expandableText';
export default {
  components: {
    expandableText: expandableText
  }
};